<template>
    <div data-aos-easing="ease" data-aos-duration="400" data-aos-delay="0" v-resize="onResize">
      <v-slide-y-reverse-transition hide-on-leave>
        <section v-if="loadedPage" class="home-image">
          <!-- height: 89vh; -->
          <v-row>
            <v-col cols="12" v-if="!isMobile" style="height: 100%;">
              <!-- <div :style="'background-image: url(' + baseUrl + 'img/webapp/dgtu-rostov.jpg); min-height: '+ (isMobile ? 300 : 550) + 'px;'">
              </div> -->
              <div style="height: 100%;">
                <v-img v-if="loadedPage" class="section-imageBase" style="height: 200px;border-radius: 20px;" :src="baseUrl + 'img/webapp/fonDgtu.jpg'">
                  <v-card v-if="false" elevation="0" :target="'_blank'" href="https://lk.donstu.ru/WebApp/#/Authorize?state=399dbb40f3fd6b3647aff6e25039d207&response_type=code&approval_prompt=auto&redirect_uri=https%3A%2F%2Fmy.e.donstu.ru%2Fadmin%2Fuser%2Fauth%2Foauth%2FClient%2Fcallback%2Fmmis&client_id=529618" class="btn-primary _contrast mx-4 pa-4 d-flex link mb-2 pa-3 py-2" style="width: 98%;border-radius: 8px;text-transform: inherit;min-height: 60px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;position: absolute;bottom: 10px;left: 0px;">
                    <div>Дни навигации первокурсника</div>
                    <v-spacer/>
                    <v-icon
                      right
                      dark
                      style="border-radius: 4px; background: #1370B9"
                      color="#fff"
                      class="pa-2"
                      small
                    >
                    mdi-chevron-right
                    </v-icon>
                  </v-card>
                </v-img>
              </div>
            </v-col>
            <v-col cols="12" md="4" lg="4" xl="5" v-if="!isMobile && false" style="height: 100%;">
              <!-- <div :style="'background-image: url(' + baseUrl + 'img/webapp/dgtu-rostov.jpg); min-height: '+ (isMobile ? 300 : 550) + 'px;'">
              </div> -->
              <div style="height: 100%;">
                <v-img v-if="true" style="height: 100%;border-radius: 20px;" :src="baseUrl + 'img/webapp/dgtu-rostov.jpg'"/>
              </div>
            </v-col>
            <!-- md="8" lg="8" xl="7" -->
            <v-col cols="12" class="px-0" style="height: 100%;">
              <v-slide-y-reverse-transition hide-on-leave>
              <div v-if="loadedPage">
                <v-row class="mx-0" :class="isMobile ? 'mx-n2': ''" style="">
                  <v-col v-if="false" cols="12" >
                    <div style="height: 100%;">
                      <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: none;">
                          <h3 class="mx-3 my-1 mb-2">Первокурсникам</h3>
                          <v-row>
                            <v-col cols="12" class="mt-2">
                              <v-card :target="'_blank'" href="https://lk.donstu.ru/WebApp/#/Authorize?state=399dbb40f3fd6b3647aff6e25039d207&response_type=code&approval_prompt=auto&redirect_uri=https%3A%2F%2Fmy.e.donstu.ru%2Fadmin%2Fuser%2Fauth%2Foauth%2FClient%2Fcallback%2Fmmis&client_id=529618" class="d-flex mx-3 card-primary mb-2 pa-3 py-2" :style="!isDark ? 'border: none;':''">
                                <span class="card-primary-background" style="background-image: linear-gradient(186.536deg, rgb(17, 80, 155) 0%, rgb(38, 136, 213) 100%);"></span>
                                <div class="card-text-button">
                                  Дни навигации первокурсника
                                  <v-icon small class="external-link-inline">mdi-open-in-new</v-icon>
                                </div>
                                <v-spacer/>
                                <v-icon
                                  right
                                  dark
                                  color="#fff"
                                  class="pa-2 card-primary-icon"
                                  small
                                >
                                mdi-chevron-right
                                </v-icon>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-card>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="4">
                    <div style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index < 5).length > 0">
                      <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: none;">
                          <h3 class="mx-3 my-1 mb-2">Общее</h3>
                          <v-row>
                            <v-col cols="12" class="mt-2">
                              <v-card :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index < 5)" :key="item.menuItemID" class="d-flex mx-3 card-primary mb-2 pa-3 py-2" :style="!isDark ? 'border: none;':''">
                                <span class="card-primary-background" style="background-image: linear-gradient(186.536deg, rgb(17, 80, 155) 0%, rgb(38, 136, 213) 100%);"></span>
                                <div class="card-text-button">
                                  {{item.text}}
                                  <v-icon v-if="isExternalLink(item.href)" small class="external-link-inline">mdi-open-in-new</v-icon>
                                </div>
                                <v-spacer/>
                                <v-icon
                                  right
                                  dark
                                  color="#fff"
                                  class="pa-2 card-primary-icon"
                                  small
                                >
                                mdi-chevron-right
                                </v-icon>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-card>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="4">
                    <div style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 5 && index < 10).length > 0">
                      <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: none;">
                          <h3 class="mx-3 my-1 mb-2">Профильное</h3>
                          <v-row>
                            <v-col cols="12" class="mt-2">
                              <v-card :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 5 && index < 10)" :key="item.menuItemID" class="d-flex mx-3 card-primary mb-2 pa-3 py-2" :style="!isDark ? 'border: none;':''">
                                <span class="card-primary-background" style="background-image: linear-gradient(186.536deg, rgb(17, 80, 155) 0%, rgb(38, 136, 213) 100%);"></span>
                                <div class="card-text-button">
                                  {{item.text}}
                                  <v-icon v-if="isExternalLink(item.href)" small class="external-link-inline">mdi-open-in-new</v-icon>
                                </div>
                                <v-spacer/>
                                <v-icon
                                  right
                                  dark
                                  color="#fff"
                                  class="pa-2 card-primary-icon"
                                  small
                                >
                                mdi-chevron-right
                                </v-icon>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-card>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="4">
                    <div style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 10 && index <= 14).length > 0">
                      <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: none;">
                          <h3 class="mx-3 my-1 mb-2">Прочее</h3>
                          <v-row>
                            <v-col cols="12" class="mt-2">
                              <v-card :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 10 && index <= 14)" :key="item.menuItemID" class="d-flex mx-3 card-primary mb-2 pa-3 py-2" :style="!isDark ? 'border: none;':''">
                                <span class="card-primary-background" style="background-image: linear-gradient(186.536deg, rgb(17, 80, 155) 0%, rgb(38, 136, 213) 100%);"></span>
                                <div class="card-text-button">
                                  {{item.text}}
                                  <v-icon v-if="isExternalLink(item.href)" small class="external-link-inline">mdi-open-in-new</v-icon>
                                </div>
                                <v-spacer/>
                                <v-icon
                                  right
                                  dark
                                  color="#fff"
                                  class="pa-2 card-primary-icon"
                                  small
                                >
                                mdi-chevron-right
                                </v-icon>
                              </v-card>
                            </v-col>
                          </v-row>
                      </v-card>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="4">
                    <div style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 15).length > 0">
                      <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: none;">
                          <h3 class="mx-3 my-1 mb-2">Прочее</h3>
                          <v-row>
                            <v-col cols="12" class="mt-2">
                              <v-card :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 15)" :key="item.menuItemID" class="d-flex mx-3 card-primary mb-2 pa-3 py-2" :style="!isDark ? 'border: none;':''">
                                <span class="card-primary-background" style="background-image: linear-gradient(186.536deg, rgb(17, 80, 155) 0%, rgb(38, 136, 213) 100%);"></span>
                                <div class="card-text-button">
                                  {{item.text}}
                                  <v-icon v-if="isExternalLink(item.href)" small class="external-link-inline">mdi-open-in-new</v-icon>
                                </div>
                                <v-spacer/>
                                <v-icon
                                  right
                                  dark
                                  color="#fff"
                                  class="pa-2 card-primary-icon"
                                  small
                                >
                                mdi-chevron-right
                                </v-icon>
                              </v-card>
                            </v-col>
                          </v-row>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="false">
                  <v-col v-if="true" cols="12">
                      <v-row class="mx-0" style="">
                        <v-col cols="12" lg="4">
                          <v-row style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index < 4).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <h3 class="mx-3">Обучение</h3>
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index < 4)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                        
                        <v-col cols="12" lg="4">
                          <v-row style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 4 && index < 9).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <h3 class="mx-3">Сотрудникам</h3>
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 4 && index < 9)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                        
                        <v-col cols="12" lg="4">
                          <v-row style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 9 && index < 13).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <h3 class="mx-3">Прочее</h3>
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 9 && index < 13)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                          <v-row style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 13 && index < 18).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 13 && index < 18)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 18).length > 0" cols="12" lg="12">
                          <v-row style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 18 && index < 24).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" color="#1370b9" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 18 && index < 24)" :key="item.menuItemID" class="d-flex link-blue mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #ffffff;background: #1370b9;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #ffffff;"
                                        color="#1370B9"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                    <!-- <v-card :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" :style="(item.color ? 'border-bottom: 5px solid ' + item.color + ';': '')" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index < 4)" :key="item.menuItemID" class="d-flex mb-3" style="letter-spacing: 0.01em;background: #F5F5F5;box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.2);border-radius: 10px;min-height: 55px;justify-content: center;align-items: center;border-bottom: 5px solid #033698b3;font-weight: 600;font-size: 18px;line-height: 24px;color: #4F4F4F;">
                                      <div>{{item.text}}</div>
                                    </v-card> -->
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                          <v-row style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 24).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 24)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                  </v-col>
                  <v-col v-if="!isMobile && false" cols="12">
                    <vue-perfect-scrollbar :settings="scrollSettings" style="height: 81.5vh;">
                      <v-row class="mx-0" style="max-height: calc(100vh - 300px);height: 100%;">
                        <!-- <v-col cols="12" lg="4">
                          <v-row v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index < 4).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <h3 class="mx-3">Олежко - программист</h3>
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index < 4)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                          <v-row v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 4 && index < 9).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" color="#1370b9" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <h3 class="mx-3 white--text">Тестируем</h3>
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 4 && index < 9)" :key="item.menuItemID" class="d-flex link-blue mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #ffffff;background: #1370b9;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #ffffff;"
                                        color="#1370B9"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" lg="4">
                          <v-row v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 9 && index < 13).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <h3 class="mx-3">Тестируем</h3>
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 9 && index < 13)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                          <v-row v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 13 && index < 18).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 13 && index < 18)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col> -->
                        <v-col cols="12" lg="4" style="height: 97%;">
                          <v-row style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index < 4).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <h3 class="mx-3">Обучение</h3>
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index < 4)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                        
                        <v-col cols="12" lg="4" style="height: 97%;">
                          <v-row style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 4 && index < 9).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <h3 class="mx-3">Сотрудникам</h3>
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 4 && index < 9)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                        <!-- <v-col cols="12" lg="4" style="height: 97%;">
                          <v-row style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 4 && index < 9).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" color="#1370b9" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <h3 class="mx-3 white--text">Сотрудникам</h3>
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 4 && index < 9)" :key="item.menuItemID" class="d-flex link-blue mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #ffffff;background: #1370b9;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #ffffff;"
                                        color="#1370B9"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col> -->
                        <v-col cols="12" lg="4" style="height: 97%;">
                          <v-row style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 9 && index < 13).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <h3 class="mx-3">Прочее</h3>
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 9 && index < 13)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                          <v-row style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 13 && index < 18).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 13 && index < 18)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col style="height: 97%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 18).length > 0" cols="12" lg="12">
                          <v-row style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 18 && index < 24).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" color="#1370b9" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 18 && index < 24)" :key="item.menuItemID" class="d-flex link-blue mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #ffffff;background: #1370b9;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #ffffff;"
                                        color="#1370B9"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                    <!-- <v-card :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" :style="(item.color ? 'border-bottom: 5px solid ' + item.color + ';': '')" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index < 4)" :key="item.menuItemID" class="d-flex mb-3" style="letter-spacing: 0.01em;background: #F5F5F5;box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.2);border-radius: 10px;min-height: 55px;justify-content: center;align-items: center;border-bottom: 5px solid #033698b3;font-weight: 600;font-size: 18px;line-height: 24px;color: #4F4F4F;">
                                      <div>{{item.text}}</div>
                                    </v-card> -->
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                          <v-row style="height: 100%;" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 24).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 24)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </vue-perfect-scrollbar>
                  </v-col>
                  <v-col v-if="isMobile && false" cols="12">
                      <v-row >
                        <v-col cols="12" lg="6">
                          <v-row v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index < 4).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index < 4)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;border: 1px solid #D2DAE3;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                          <v-row v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 4 && index < 9).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" color="#1370b9" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 4 && index < 9)" :key="item.menuItemID" class="d-flex link-blue mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;border: 1px solid #D2DAE3;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #ffffff;background: #1370b9;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #ffffff;"
                                        color="#1370B9"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                    <!-- <v-card :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" :style="(item.color ? 'border-bottom: 5px solid ' + item.color + ';': '')" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index < 4)" :key="item.menuItemID" class="d-flex mb-3" style="letter-spacing: 0.01em;background: #F5F5F5;box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.2);border-radius: 10px;min-height: 55px;justify-content: center;align-items: center;border-bottom: 5px solid #033698b3;font-weight: 600;font-size: 18px;line-height: 24px;color: #4F4F4F;">
                                      <div>{{item.text}}</div>
                                    </v-card> -->
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" lg="6">
                          <v-row v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 9 && index < 13).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 9 && index < 13)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;border: 1px solid #D2DAE3;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                          <v-row v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 13 && index < 18).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 13 && index < 18)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;border: 1px solid #D2DAE3;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 18).length > 0" cols="12" lg="12">
                          <v-row v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 18 && index < 24).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" color="#1370b9" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 18 && index < 24)" :key="item.menuItemID" class="d-flex link-blue mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;border: 1px solid #D2DAE3;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #ffffff;background: #1370b9;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #ffffff;"
                                        color="#1370B9"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                    <!-- <v-card :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" :style="(item.color ? 'border-bottom: 5px solid ' + item.color + ';': '')" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index < 4)" :key="item.menuItemID" class="d-flex mb-3" style="letter-spacing: 0.01em;background: #F5F5F5;box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.2);border-radius: 10px;min-height: 55px;justify-content: center;align-items: center;border-bottom: 5px solid #033698b3;font-weight: 600;font-size: 18px;line-height: 24px;color: #4F4F4F;">
                                      <div>{{item.text}}</div>
                                    </v-card> -->
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                          <v-row v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 24).length > 0">
                            <v-col cols="12" lg="12" xl="12" class="pb-1" style="max-width: 100%;">
                              <v-card class="pa-3" elevation="0" style="border-radius: 15px;height: 100%;border: 1px solid rgb(230, 230, 230);">
                                <v-row>
                                  <v-col cols="12" class="mt-2">
                                    <v-card elevation="0" :target="item.newTab === true ? '_blank' : ''" :href="item.href ? item.href : null" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index >= 24)" :key="item.menuItemID" class="d-flex link mb-2 pa-3 py-2" style="border-radius: 8px;text-transform: inherit;min-height: 40px;border: 1px solid #D2DAE3;align-items: center;transition: color .35s ease, box-shadow .35s ease, background-color .35s ease, background .35s ease;font-size: 16px;font-weight: 500;color: #38424F;">
                                      <div>{{item.text}}</div>
                                      <v-spacer/>
                                      <v-icon
                                        right
                                        dark
                                        style="border-radius: 4px; background: #1370B9"
                                        color="#fff"
                                        class="pa-2"
                                        small
                                      >
                                      mdi-chevron-right
                                      </v-icon>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                  </v-col>
                </v-row>
              </div>
              </v-slide-y-reverse-transition>
            </v-col>
          </v-row>
        </section>
      </v-slide-y-reverse-transition>
      <section v-if="false" class="home-section home-fade home-full-height bg-dark-60 landing-header parallax-bg aos-init" id="home" :style="'background-image: url(' + baseUrl + 'img/webapp/fonDgtu.jpg); min-height: '+ (isMobile ? 300 : 490) + 'px;'" v-intersect="onIntersectSection1">
        <div class="titan-caption" style="position: absolute;bottom: 0;">
          <div class="caption-content" style="position: relative;">
            <div class="container">
              <v-row :class="{'mt-16': !isMobile}">
                <!-- <v-col cols="12" lg="3">
                  <v-img
                    style="margin: 0 auto;"
                    max-height="500"
                    :max-width="isMobile ? 70 : 250"
                    :src="baseUrl + 'img/webapp/dstuWhite.png'"
                  ></v-img>
                </v-col> -->
                <!-- <v-col cols="12" lg="6" class="pa-5" :data-aos="!isMobile ? 'fade-left' : null" :class="{'aos-animate' : isIntersecting.section1, 'aos-init' : !isMobile}" >
                  <div class="mb-3">
                    <div class="text-left white--text mb-3" :class="{'text-center' : isMobile, 'site-title': !isMobile, 'site-title-mobile': isMobile}">Электронная информационно-образовательная среда ДГТУ</div>
                    <p v-if="!isMobile" class="white--text" style="font-size: 20px;font-weight: 400;" :class="{'text-center' : isMobile}">Данный сайт представляет собой Интернет-расширение информационной системы ДГТУ, созданное для студентов, их родителей и сотрудников университета.</p>
                  </div>
                  <div class="mt-8">
                    <v-btn
                      rounded
                      v-for="(item) in mainMenuItems" :key="item.menuItemID"
                      :color="'white'"
                      class="mr-6 mb-6 text--primary"
                      :class="{'ml-0' : isMobile}"
                      :href="item.href"
                      :target="item.newTab === true ? '_blank' : ''"
                      :small="isMobile"
                    >
                      {{item.text}}
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="12" class="ma-0 pa-5" :class="{'text-center' : isMobile}">
                  <div class="px-15 mt-2">

                  </div>
                </v-col> -->
                <v-col cols="12" lg="8" class="pa-5" :data-aos="!isMobile ? 'fade-left' : null" :class="{'aos-animate' : isIntersecting.section1, 'aos-init' : !isMobile}" >
                  <div class="mb-3">
                    <div class="ml-3 textSite text-left white--text mb-3" :class="{'site-title': !isMobile, 'site-title-mobile': isMobile}">{{initInfo.homeTitul ? initInfo.homeTitul : 'Электронная информационно-образовательная среда ДГТУ'}}</div>
                    <!-- <p v-if="!isMobile" class="white--text" style="font-size: 20px;font-weight: 400;" :class="{'text-center' : isMobile}">Данный сайт представляет собой Интернет-расширение информационной системы ДГТУ, созданное для студентов, их родителей и сотрудников университета.</p> -->
                  </div>
                  <div class="mt-8" v-if="false">
                    <v-btn
                      rounded
                      v-for="(item) in mainMenuItems" :key="item.menuItemID"
                      :color="'white'"
                      class="mr-6 mb-6 text--primary"
                      :class="{'ml-0' : isMobile}"
                      :href="item.href"
                      :target="item.newTab === true ? '_blank' : ''"
                      :small="isMobile"
                    >
                      {{item.text}}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </section>
      <section v-if="false" class="ma-6">
        <v-row>
          <v-col cols="12" lg="6" xl="4" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index <= 3).length > 0">
            <v-card class="pa-3" style="border-radius: 10px;height: 100%;">
              <v-card elevation="0">
                <v-row class="ml-0">
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pl-0 pr-3" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index <= 3)" :key="item.menuItemID">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="item.description !== null ? on: false" class="course" style="cursor:pointer" :href="item.href ? item.href : null" :target="item.newTab === true ? '_blank' : ''">
                          <div class="course-preview" :style="item.gradient ? 'background: linear-gradient(316.78deg,' + item.color + ' 18.63%,' + item.colorGradient + ' 77.82%);' : (item.color ? 'background:' + item.color + ';': '')" style="width: 75px;padding: 40px 20px;position: relative; background:linear-gradient(316.78deg, #2094ffb3, #033799b3);">
                            <h6 class="text-left d-flex" style="justify-content: center;">
                              <div class="mr-0" style="opacity: 1;">
                                <v-icon v-if="item.linkImg && item.linkImg.toLowerCase().startsWith('fa'.toLowerCase())" color="white">{{item.linkImg != null ? item.linkImg : 'fas fa-globe'}}</v-icon>
                                <svgIcon v-else-if="item.linkImg && item.linkImg.toLowerCase().startsWith('svg'.toLowerCase())" fill="#ffffff" :iconName="item.linkImg" :width="28" :height="24"></svgIcon>
                              </div>
                            </h6>
                          </div>
                          <div class="course-info" style="overflow: hidden;">
                            <h2 class="pr-2 pl-1 mb-3" style="font-family: 'Montserrat';font-style: normal;font-weight: 600;font-size: 18px;line-height: 24px;color: #004992;letter-spacing: 0.01em;max-width: 290px;">{{item.text}}</h2>
                            <div class="d-flex mt-1 ml-n1" style="position: absolute;bottom: 10px;margin-left: 1px !important;">
                            </div>
                          </div>
                        </v-card>
                      </template>
                      <span>{{item.description}}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-card>
            </v-card>
          </v-col>
          <v-col cols="12" lg="6" xl="4" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index > 3 && index <= 7).length > 0">
            <v-card class="pa-3" style="border-radius: 10px;height: 100%;">
              <v-card elevation="0">
                <v-row class="ml-0">
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pl-0 pr-3" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index > 3 && index <= 7)" :key="item.menuItemID">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="item.description !== null ? on: false" class="course" style="cursor:pointer" :href="item.href ? item.href : null" :target="item.newTab === true ? '_blank' : ''">
                          <div class="course-preview" :style="item.gradient ? 'background: linear-gradient(316.78deg,' + item.color + ' 18.63%,' + item.colorGradient + ' 77.82%);' : (item.color ? 'background:' + item.color + ';': '')" style="width: 75px;padding: 40px 20px;position: relative; background:linear-gradient(316.78deg, #2094ffb3, #033799b3);">
                            <h6 class="text-left d-flex" style="justify-content: center;">
                              <div class="mr-0" style="opacity: 1;">
                                <v-icon v-if="item.linkImg && item.linkImg.toLowerCase().startsWith('fa'.toLowerCase())" color="white">{{item.linkImg != null ? 'fas ' + item.linkImg : 'fas fa-globe'}}</v-icon>
                                <svgIcon v-else-if="item.linkImg && item.linkImg.toLowerCase().startsWith('svg'.toLowerCase())" :iconName="item.linkImg" fill="#ffffff" :width="28" :height="24"></svgIcon>
                              </div>
                            </h6>
                          </div>
                          <div class="course-info" style="overflow: hidden;">
                            <h2 class="pr-2 pl-1 mb-3" style="font-family: 'Montserrat';font-style: normal;font-weight: 600;font-size: 18px;line-height: 24px;color: #004992;letter-spacing: 0.01em;max-width: 290px;">{{item.text}}</h2>
                            <div class="d-flex mt-1 ml-n1" style="position: absolute;bottom: 10px;margin-left: 1px !important;">
                            </div>
                          </div>
                        </v-card>
                      </template>
                      <span>{{item.description}}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-card>
            </v-card>
          </v-col>
          <v-col cols="12" lg="6" xl="3" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index > 7 && index <= 9).length > 0">
            <v-card class="pa-3" style="border-radius: 10px; height: 100%;">
              <v-card elevation="0">
                <v-row class="ml-0">
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pl-0 pr-3" v-for="item in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index > 7 && index <= 9)" :key="item.menuItemID">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="item.description !== null ? on: false" class="course" style="cursor:pointer" :href="item.href ? item.href : null" :target="item.newTab === true ? '_blank' : ''">
                          <!-- @click="item.href ? $router.push(item.href) : true" -->
                          <div class="course-preview" :style="item.gradient ? 'background: linear-gradient(316.78deg,' + item.color + ' 18.63%,' + item.colorGradient + ' 77.82%);' : (item.color ? 'background:' + item.color + ';': '')" style="width: 75px;padding: 40px 20px;position: relative; background:linear-gradient(316.78deg, #2094ffb3, #033799b3);">
                            <h6 class="text-left d-flex" style="justify-content: center;">
                              <div class="mr-0" style="opacity: 1;">
                                <v-icon v-if="item.linkImg && item.linkImg.toLowerCase().startsWith('fa'.toLowerCase())" color="white">{{item.linkImg != null ? 'fas ' + item.linkImg : 'fas fa-globe'}}</v-icon>
                                <svgIcon v-else-if="item.linkImg && item.linkImg.toLowerCase().startsWith('svg'.toLowerCase())" :iconName="item.linkImg" fill="#ffffff" :width="28" :height="24"></svgIcon>
                              </div>
                            </h6>
                          </div>
                          <div class="course-info" style="overflow: hidden;">
                            <h2 class="pr-2 pl-1 mb-3" style="font-family: 'Montserrat';font-style: normal;font-weight: 600;font-size: 18px;line-height: 24px;color: #004992;letter-spacing: 0.01em;max-width: 290px;">{{item.text}}</h2>
                            <div class="d-flex mt-1 ml-n1" style="position: absolute;bottom: 10px;margin-left: 1px !important;">
                            </div>
                          </div>
                        </v-card>
                      </template>
                      <span>{{item.description}}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-card>
            </v-card>
          </v-col>
          <v-col cols="12" lg="6" xl="4" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index > 9).length > 0">
              <v-card class="pa-3" style="border-radius: 10px; height: 100%;">
                <v-card elevation="0">
                  <v-row class="ml-0">
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pl-0 pr-3" v-for="item in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index > 9)" :key="item.menuItemID">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-card v-bind="attrs" v-on="item.description !== null ? on: false" class="course" style="cursor:pointer" :href="item.href ? item.href : null" >
                            <!-- @click="item.href ? $router.push(item.href) : true" -->
                            <div class="course-preview" :style="item.gradient ? 'background: linear-gradient(316.78deg,' + item.color + ' 18.63%,' + item.colorGradient + ' 77.82%);' : (item.color ? 'background:' + item.color + ';': '')" style="width: 75px;padding: 40px 20px;position: relative; background:linear-gradient(316.78deg, #2094ffb3, #033799b3);">
                              <h6 class="text-left d-flex" style="justify-content: center;">
                                <div class="mr-0" style="opacity: 1;">
                                  <v-icon v-if="item.linkImg && item.linkImg.toLowerCase().startsWith('fa'.toLowerCase())" color="white">{{item.linkImg != null ? 'fas ' + item.linkImg : 'fas fa-globe'}}</v-icon>
                                  <svgIcon v-else-if="item.linkImg && item.linkImg.toLowerCase().startsWith('svg'.toLowerCase())" :iconName="item.linkImg" fill="#ffffff" :width="28" :height="24"></svgIcon>
                                </div>
                              </h6>
                            </div>
                            <div class="course-info" style="overflow: hidden;">
                              <h2 class="pr-2 pl-1 mb-3" style="font-family: 'Montserrat';font-style: normal;font-weight: 600;font-size: 18px;line-height: 24px;color: #004992;letter-spacing: 0.01em;max-width: 290px;">{{item.text}}</h2>
                              <div class="d-flex mt-1 ml-n1" style="position: absolute;bottom: 10px;margin-left: 1px !important;">
                              </div>
                            </div>
                          </v-card>
                        </template>
                        <span>{{item.description}}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>
          </v-col>
        </v-row>
      </section>
      <!-- <section class="home-section home-fade home-full-height bg-dark-60 landing-header parallax-bg aos-init" id="home" :style="'background-image: url(' + baseUrl + 'img/webapp/fon.jpg); min-height: '+ (isMobile ? 300 : 600) + 'px;'" v-intersect="onIntersectSection1">
        <div class="titan-caption">
          <div class="caption-content" style="position: relative;">
            <div class="container">
              <v-row :class="{'mt-16': !isMobile}">
                <v-col cols="12" lg="3">
                  <v-img
                    style="margin: 0 auto;"
                    max-height="500"
                    :max-width="isMobile ? 70 : 250"
                    :src="baseUrl + 'img/webapp/dstuWhite.png'"
                  ></v-img>
                </v-col>
                <v-col cols="12" lg="6" class="pa-5" :data-aos="!isMobile ? 'fade-left' : null" :class="{'aos-animate' : isIntersecting.section1, 'aos-init' : !isMobile}" >
                  <div class="mb-3">
                    <div class="text-left white--text mb-3" :class="{'text-center' : isMobile, 'site-title': !isMobile, 'site-title-mobile': isMobile}">Электронная информационно-образовательная среда ДГТУ</div>
                    <p v-if="!isMobile" class="white--text" style="font-size: 20px;font-weight: 400;" :class="{'text-center' : isMobile}">Данный сайт представляет собой Интернет-расширение информационной системы ДГТУ, созданное для студентов, их родителей и сотрудников университета.</p>
                  </div>
                  <div class="mt-8">
                    <v-btn
                      rounded
                      v-for="(item) in mainMenuItems" :key="item.menuItemID"
                      :color="'white'"
                      class="mr-6 mb-6 text--primary"
                      :class="{'ml-0' : isMobile}"
                      :href="item.href"
                      :target="item.newTab === true ? '_blank' : ''"
                      :small="isMobile"
                    >
                      {{item.text}}
                    </v-btn>
                  </div>

                </v-col>
                <v-col cols="12" class="ma-0 pa-5" :class="{'text-center' : isMobile}">
                  <div class="px-15 mt-2">

                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </section>
      <section class="module-medium pt-8">
          <div class="" :data-aos="!isMobile ? 'fade-up' : null" :class="{'aos-animate' : isIntersecting.section2, 'aos-init container' : !isMobile}">
            <v-row>
              <v-col cols="12">
                <h2 class="module-title font-alt">Новости сайта</h2>
                <div class="mt-5" v-intersect="onIntersectSection2">
                  <v-carousel v-if="news.length > 0" hide-delimiters transition="fade-transition" interval="1000" class="carouselNews" style="min-height: 600px;height: 100%;">
                    <template v-for="(item, index) in news">
                      <v-carousel-item v-if="(index + 1) % columns === 1 || columns === 1" :key="index" style="min-height: 600px;">
                        <v-row class="flex-nowrap px-15" style="height:100%">
                            <template v-if="(+index) < news.length">
                              <v-col :key="iCol" v-for="(n,iCol) in columns" class="pa-5">
                                  <v-card v-if="(+index+ iCol) < news.length" min-height="550px" flat style="border-radius: 15px !important;box-shadow: 2px -3px 6px rgba(0, 0, 0, 0.15), 0px 4px 9px rgba(0, 0, 0, 0.25) !important;">
                                    <img
                                      :src="news[+index+ iCol].srcImg"
                                      onerror="this.onerror=null;this.src='https://edu.donstu.ru/img/news/newss.jpg';"
                                      style="position: relative;width: 100%;max-height: 100vh;background-size: cover;background-position: 50%;"
                                    />
                                    <v-card-title style="word-break: break-word;">{{news[+index+ iCol].title}}</v-card-title>
                                    <v-card-text v-html="news[+index+ iCol].description" class="mb-6"></v-card-text>
                                  </v-card>
                              </v-col>
                            </template>
                        </v-row>
                      </v-carousel-item>
                    </template>
                  </v-carousel>
                </div>
              </v-col>
            </v-row>
          </div>
      </section>
      <section class="module landing-reason parallax-bg" :style="'background-image: url(' + baseUrl + 'img/webapp/fon1.jpg);'" style="padding: 140px 0;background-repeat: no-repeat;background-position: 50% 50%;background-size: cover;">
          <v-container style="max-width: 1400px;">
            <v-row class="py-0">
              <v-col cols="12" md="6" class="py-0" v-intersect="onIntersectSection3">
                <v-img
                  :data-aos="!isMobile ? 'fade-right' : null"
                  :data-aos-easing="!isMobile ? 'ease-out-back' : null"
                  :class="{'aos-animate' : isIntersecting.section3, 'aos-init' : !isMobile}"
                  :src="baseUrl + 'img/webapp/mobile_fon1.png?t=1'"
                ></v-img>
              </v-col>
              <v-col cols="12" md="6" class="py-0 px-8" :data-aos="!isMobile ? 'fade-left' : null" :class="{'aos-animate' : isIntersecting.section3, 'aos-init' : !isMobile}">
                <h2 class="module-title text-left" style="letter-spacing: 1px;">Теперь удобно пользоваться сайтом на разных устройствах!</h2>
                <p class="module-subtitle text-left white--text my-4 mb-7" style="position: relative;">Адаптивный дизайн сайта позволяет пользователям гораздо легче и удобнее пользоваться одним и тем же интерфейсом на разных устройствах.</p>
                <v-list-item class="white--text px-0">
                  <v-list-item-action class="mr-4">
                    <v-icon class="white--text">mdi-cellphone</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Адаптивный дизайн сайта</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="white--text px-0">
                  <v-list-item-action class="mr-4">
                    <v-icon class="white--text">mdi-calendar-text-outline</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Новые возможности для преподавателей</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="white--text px-0">
                  <v-list-item-action class="mr-4">
                    <v-icon class="white--text">mdi-eye</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Обновлённый внешний вид большинства разделов</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="white--text px-0">
                  <v-list-item-action class="mr-4">
                    <v-icon class="white--text">mdi-filter</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Фильтры для облегчения поиска нужной информации</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="white--text px-0">
                  <v-list-item-action class="mr-4">
                    <v-icon class="white--text">mdi-image-multiple-outline</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>И многое другое!</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-container>
      </section>
      <section>
            <div>
              <v-carousel
                cycle
                height="400"
                transition="fade-transition"
                hide-delimiter-background
                show-arrows-on-hover
              >
                <v-carousel-item>
                  <v-sheet
                    height="100%"
                  >
                    <v-row
                      class="fill-height mx-0"
                      align="center"
                      justify="center"
                    >
                      <div class="text-left" :class="{'text-center': isMobile}">
                        <p style="line-height: 30px;">
                            Студенты могут здесь просмотреть:<br>
                            - проверить правильность заполнения своего рейтинга, оценок и пересдач;
                            <br>
                            - узнать телефоны и номера аудиторий кафедр и деканатов;
                            <br>
                            - свою сводную ведомость успеваемости по итогам сессии;<br>
                            - расписание и график учебного процесса группы;
                            <br>
                            - свою электронную зачетную книжку.
                        </p>
                        <v-chip
                          class="ma-2"
                          color="#243a51"
                          text-color="white"
                        >
                          <v-icon left>
                            mdi-user
                          </v-icon>
                          <span class="author text-uppercase">Студент</span>
                        </v-chip>
                      </div>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>
                <v-carousel-item>
                  <v-sheet
                    height="100%"
                  >
                    <v-row
                      class="fill-height mx-0"
                      align="center"
                      justify="center"
                    >
                      <div class="text-left" :class="{'text-center': isMobile}">
                        <p style="line-height: 30px;">
                            Сотрудники и преподаватели университета могут получить информацию:
                            <br>
                            - найти информацию о студенте, группе, специальности, факультете и многое другое;<br>
                            - статистику по заполнению электронных рейтинговых ведомостей;<br>
                            - списки незаполненных и незакрытых ведомостей своей кафедры;<br>
                            - по контингенту студентов университета.
                        </p>
                        <v-chip
                          class="my-2"
                          color="#243a51"
                          text-color="white"
                        >
                          <v-icon left>
                            mdi-user
                          </v-icon>
                          <span class="author text-uppercase">Сотрудник и преподаватель</span>
                        </v-chip>
                      </div>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
            </div>
      </section> -->
    </div>
</template>

<script>
import svgIcon from '@/components/ui/svgIcon'
import menu from '@/helpers/api/menu'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: 'MainPage',
  components: {
    svgIcon,
    VuePerfectScrollbar
  },
  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 160
    },
    mainMenuItems: [],
    news: [],
    isIntersecting: {
      section1: false,
      section2: false,
      section3: true
    },
    isMobile: false,
    loadedPage: false
  }),
  methods: {
    onIntersectSection1 (entries) {
      if (this.isMobile) return true
      this.isIntersecting.section1 = entries[0].isIntersecting
    },
    onIntersectSection2 (entries) {
      if (this.isMobile) return true
      this.isIntersecting.section2 = entries[0].isIntersecting
    },
    onIntersectSection3 (entries) {
      if (this.isMobile) return true
      this.isIntersecting.section3 = entries[0].isIntersecting
    },
    onResize () {
      if (window.innerWidth < 960) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    isExternalLink (href) {
      return typeof href === 'string' && /^https?:\/\//i.test(href)
    },
  },
  computed: {
    isDark () {
      return this.$vuetify.theme.dark
    },
    initInfo () {
      return this.$store.state.initInfo
    },
    baseUrl () {
      return process.env.BASE_URL
    },
    columns () {
      if (this.$vuetify.breakpoint.xl) {
        return 3
      }
      if (this.$vuetify.breakpoint.lg) {
        return 3
      }
      if (this.$vuetify.breakpoint.md) {
        return 2
      }
      return 1
    },
    cuser () {
      return this.$store.getters.cuser
    },
    authenticated () {
      return this.$store.getters.authenticated
    }
  },
  async created () {
    this.$vuetify.theme.dark = 'dark' === (localStorage.getItem('baseTheme') || 'light')
  },
  async mounted () {
    setInterval(() => { this.loadedPage = true }, 300)
    this.mainMenuItems = await menu.getMenuItems(1)
    this.mainMenuItems.forEach(item => {
      item.href = item.href.replace('https://lk.donstu.ru', '')
    })
  }
}
</script>
<style>
/* @font-face {
  font-family: "Nagel Regular";
  src: url('/fonts/Nagel/Nagel_Regular.otf');
}
@font-face {
  font-family: "Nagel Bold";
  src: url('/fonts/Nagel/Nagel_Bold.otf');
}
@font-face {
  font-family: "Nagel Medium";
  src: url('/fonts/Nagel/Nagel_Medium.otf');
} */
@font-face {
  font-display: swap;
  font-family: Golos;
  font-style: normal;
  font-weight: 400;
  src: url('/fonts/golos/400.woff2') format("woff2"),url('/fonts/golos/400.woff') format("woff")
}

@font-face {
  font-display: swap;
  font-family: Golos;
  font-style: normal;
  font-weight: 500;
  src: url('/fonts/golos/500.woff2') format("woff2"),url('/fonts/golos/500.woff') format("woff")
}

@font-face {
  font-display: swap;
  font-family: Golos;
  font-style: normal;
  font-weight: 600;
  src: url('/fonts/golos/600.woff2') format("woff2"),url('/fonts/golos/600.woff') format("woff")
}
.card-primary {
  border-radius: 0.6rem !important;
  text-transform: inherit;
  min-height: 40px;
  align-items: center;
  transition: all .35s ease;
  font-size: 16px;
  font-weight: 500;
  color: #38424F;
  background-color: transparent !important;
  box-shadow: inset 0 0 0 1px #d2dae3 !important;
  /* display: inline-flex;
  gap: 2rem;
  justify-content: space-between;
  max-width: 32rem;
  overflow: hidden;
  padding: 1.2rem 1.2rem 1.2rem 1.6rem;
  position: relative;
  width: 100%; */
}
.card-text-button {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -.24px;
  line-height: 2.4rem;
}
.card-primary-icon {
  border-radius: 4px !important; background: #1370B9;
  /* height: 2.5rem;width: 2.5rem; */
}
.card-primary span, .card-primary i, .card-primary div, .card-primary-icon {
  z-index: 2;
}
@media (hover: hover) {
  .card-primary:hover .card-primary-background {
    opacity: 1;
  }
  .card-primary:hover {
    color: #ffffff;
  }
}
.card-primary-background {
  display: block;
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  transition: opacity .5s;
  width: 100%;
  z-index: 1;
  border-radius: inherit !important;
}
.btn-primary._contrast{
  background: #ffffff30;
  box-shadow: inset 0 0 0 1px #d2dae34d !important;
  /* border: 1px solid #d2dae34d !important; */
  color: white !important;
}
.btn-primary._contrast:hover {
  /* border: none !important; */
  box-shadow: inset 0 0 0 0px #d2dae34d !important;
}
.header__inner {
  align-items: center;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.header__inner._top {
  min-height: .8rem;
  width: 100%;
}
.header__top-links {
  display: flex;
  gap: 3.2rem;
}
.header__user-actions {
  align-items: center;
  display: flex;
  gap: .8rem;
}

.header__user-actions .toggle {
  margin-left: 1.6rem;
}
.toggle {
  /* background-color: var(--gray-color-3); */
  background-color: #e7e9ed;
  border-radius: 3.2rem;
  display: flex;
  height: 2.6rem;
  position: relative;
  transition: background-color .35s ease;
  width: 4.0rem;
}
.visually-hidden {
  clip: rect(0, 0, 0, 0);
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.toggle label {
  display: flex;
  inset: 0;
  padding: .4rem;
  position: absolute;
  transition: opacity .35s ease;
}
.toggle label:first-of-type {
  opacity: 1;
}
.toggle label span {
  align-items: center;
  background-color: #ffffff;
  border-radius: 50%;
  display: flex;
  flex-shrink: 0;
  height: 1.8rem;
  justify-content: center;
  transition: transform .35s ease;
  width: 1.8rem;
}
.toggle label span svg {
  /* color: var(--text-2-color); */
  color: #80889d;
  height: 2.4rem;
  transition: transform .35s ease;
  width: 1.4rem;
}
.toggle label:first-of-type {
  opacity: 1;
}
.toggle label:first-of-type svg {
  transform: scale(1);
}
.toggle label:nth-of-type(2) svg {
  transform: scale(0);
}
@media (hover: hover) {
  .hover-box:hover .toggle.hover-item, .toggle:hover {
    /* background-color: var(--gray-color-1); */
    background-color: #d3dbe0;
  }
}
/* end */
/* .header {
  position: absolute;
  width: 100%;
  z-index: 1;
} */
.theme--light.v-application {
  background: #f4f4f4;
}
.theme--light.v-card {
  border: 1px solid rgb(230, 230, 230);
}
.theme--light.v-card.link {
  border: none;
}
.theme--dark.v-application {
  background: #1e1e1e;
  color: #FFFFFF;
}
.theme--dark.v-card {
  /* background: #232935; */
  background: #313745;
  color: #FFFFFF;
  border: none;
}
.theme--dark.link {
  /* background: #313745; */
  background: #232935;
  color: #FFFFFF !important;
}


.header__logo svg {
  height: 3.6rem;
  width: 17rem;
}
@media (max-width: 767px) {
  .header__logo svg {
    height: 2.3rem;
    width: 10.2rem;
  }
}
@media (min-width: 2050px) {
  .section-imageBase {
    height: 500px !important;
  }
}

/*
@media (min-width: 3000px) {
  .home-image > .row  {
    height: 1300px !important;
  }
}*/
.ps-container {
  height: 95vh;
  overflow: auto;
  overflow-x: hidden !important;
}
.ps__scrollbar-x-rail, .ps__scrollbar-x, .ps:hover>.ps__scrollbar-x-rail{
  display: none;
}
.link:hover{
  background-image: linear-gradient(197.895deg, rgb(16, 76, 148) 0%, rgb(31, 126, 202) 100%);
  color: white !important;
}
.link-blue:hover{
  background: white !important;
  color: #1370B9 !important;
}
.link-blue:hover .v-icon{
  background: linear-gradient(197.895deg, rgb(16, 76, 148) 0%, rgb(31, 126, 202) 100%) !important;
  color: white !important;
}
.external-link-inline {
  margin-left: 6px;
  margin-bottom: 2px;
  opacity: 0.8;
}

@import url('https://fonts.googleapis.com/css?family=Montserrat:400,500,600,700&display=swap');
.colorSoloText.v-text-field--solo>.v-input__control>.v-input__slot {
  background: #F2F2F2;
}
.textStyle {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #004992 !important;
}
.course {
  background-color: #fff;
  border-radius: 10px;
  /* box-shadow: 0 10px 10px rgba(0, 0, 0, 0.2); */
  box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.2);
  display: flex !important;
  max-width: 100%;
  overflow: hidden;
  width: 700px;
  height: 100%;
  min-height: 120px !important;
}
.course h6 {
  /* opacity: 0.6; */
  margin: 0;
  text-align: left;
  text-transform: uppercase;
}

.course h2 {
  text-align: left;
  margin: 10px 0;
}

.course-preview {
  /* background-color: var(--v-stud-base) !important; */
  color: #fff;
  /* padding: 15px; */
  padding: 15px 10px;
  max-width: 250px;
}

.course-preview a {
  color: #fff !important;
  display: inline-block;
  font-size: 12px;
  opacity: 0.6;
  /* margin-top: 30px; */
  text-decoration: none;
}

.course-info {
  /* padding: 15px; */
  background: #F5F5F5;
  padding: 15px 10px;
  position: relative;
  width: 100%;
}
.textSite{
  letter-spacing: 0.03em;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 50px;
  text-transform: uppercase;
}
/*  */
.site-title {
  font-size: 30px;
  font-weight: 600;
}
.site-title-mobile {
  font-size: 18px;
  font-weight: 600;
  line-height: 30px;
}
.carouselNews .v-carousel__item{
  min-height: 600px !important;
  height: 100% !important;
}
</style>
<style scoped>
.home-section {
  position: relative;
  background-color: #fff;
  background-repeat: no-repeat;
  box-shadow: inset 0px -26px 89px rgb(13 26 62 / 70%);
  /* background-position: center center; */
  width: 100%;
  z-index: 0;
  background-size: cover;
}
.landing-header:before {
  position: absolute;
  background: linear-gradient(177.83deg, rgb(3 36 68 / 75%) 1.78%, rgb(4 89 218 / 10%) 98.18%);
  /* linear-gradient(177.83deg, rgb(3 36 68 / 75%) 1.78%, rgb(4 89 218 / 40%) 98.18%); */
  content: " ";
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
}
.font-alt {
  font-family: "Montserrat", "Roboto Condensed", sans-serif;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.module-medium {
  padding: 75px 0px;
}
.module-title {
  position: relative;
  letter-spacing: 2px;
  text-align: center;
  font-weight: 400;
  font-size: 30px;
  color: #111;
}
/* .module-title + .module-subtitle { */
  /* margin-top: -35px; */
/* } */
.module-subtitle {
  text-align: center;
  font-size: 16px;
  color: #111;
}
.large-text {
  font-size: 24px !important;
}
/* / */
/* .parallax-bg { */
  /* background-attachment: fixed; */
  /* background-size: cover; */
/* } */
.landing-reason:before {
  position: absolute;
  content: " ";
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  /* background-color: rgb(36 58 81 / 92%); */
  background-color: rgb(31 64 98 / 92%);
}
.module,
.module-small {
  position: relative;
  padding: 140px 0;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
}

/* Module header */
.module-small {
  padding: 70px 0;
}

.module-extra-small {
  padding: 25px 0px;
}

.module-medium {
  padding: 75px 0px;
}

.holder-w {
  position: relative;
  display: table-cell;
  vertical-align: middle;
  height: 1px;
  width: 50%;
}

.holder-w:before {
  border-top: 1px solid #eaeaea;
  position: relative;
  display: block;
  content: "";
  top: 1px;
  height: 1px;
  width: 100%;
}
.landing-reason .module-title {
  /* color: #e6af4b; */
  color: #55e8ff;
}

/* .landing-reason .module-title + .module-subtitle { */
  /* margin-top: -60px; */
/* } */

.free-trial {
  background-color: rgba(88, 20, 158, 0.9);
  color: #FFFFFF;
}

.free-trial .color-golden {
  color: #e6af4b;
}


.landing-reason {
  color: #fff;
  font-size: 13px;
}

.landing-image-text {
  padding-top: 70px;
  padding-bottom: 0px;
}

.landing-image-text h2 {
  margin-top: 100px;
  margin-bottom: 15px;
}

.landing-screenshot:before {
  position: absolute;
  content: " ";
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(66, 60, 130, 0.5);
}
/** */
@media (min-width: 1264px) {
  [data-aos][data-aos][data-aos-duration='50'],div[data-aos-duration='50'] [data-aos]{transition-duration:50ms}[data-aos][data-aos][data-aos-delay='50'],div[data-aos-delay='50'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='50'].aos-animate,div[data-aos-delay='50'] [data-aos].aos-animate{transition-delay:50ms}[data-aos][data-aos][data-aos-duration='100'],div[data-aos-duration='100'] [data-aos]{transition-duration:.1s}[data-aos][data-aos][data-aos-delay='100'],div[data-aos-delay='100'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='100'].aos-animate,div[data-aos-delay='100'] [data-aos].aos-animate{transition-delay:.1s}[data-aos][data-aos][data-aos-duration='150'],div[data-aos-duration='150'] [data-aos]{transition-duration:.15s}[data-aos][data-aos][data-aos-delay='150'],div[data-aos-delay='150'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='150'].aos-animate,div[data-aos-delay='150'] [data-aos].aos-animate{transition-delay:.15s}[data-aos][data-aos][data-aos-duration='200'],div[data-aos-duration='200'] [data-aos]{transition-duration:.2s}[data-aos][data-aos][data-aos-delay='200'],div[data-aos-delay='200'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='200'].aos-animate,div[data-aos-delay='200'] [data-aos].aos-animate{transition-delay:.2s}[data-aos][data-aos][data-aos-duration='250'],div[data-aos-duration='250'] [data-aos]{transition-duration:.25s}[data-aos][data-aos][data-aos-delay='250'],div[data-aos-delay='250'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='250'].aos-animate,div[data-aos-delay='250'] [data-aos].aos-animate{transition-delay:.25s}[data-aos][data-aos][data-aos-duration='300'],div[data-aos-duration='300'] [data-aos]{transition-duration:.3s}[data-aos][data-aos][data-aos-delay='300'],div[data-aos-delay='300'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='300'].aos-animate,div[data-aos-delay='300'] [data-aos].aos-animate{transition-delay:.3s}[data-aos][data-aos][data-aos-duration='350'],div[data-aos-duration='350'] [data-aos]{transition-duration:.35s}[data-aos][data-aos][data-aos-delay='350'],div[data-aos-delay='350'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='350'].aos-animate,div[data-aos-delay='350'] [data-aos].aos-animate{transition-delay:.35s}[data-aos][data-aos][data-aos-duration='400'],div[data-aos-duration='400'] [data-aos]{transition-duration:.4s}[data-aos][data-aos][data-aos-delay='400'],div[data-aos-delay='400'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='400'].aos-animate,div[data-aos-delay='400'] [data-aos].aos-animate{transition-delay:.4s}[data-aos][data-aos][data-aos-duration='450'],div[data-aos-duration='450'] [data-aos]{transition-duration:.45s}[data-aos][data-aos][data-aos-delay='450'],div[data-aos-delay='450'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='450'].aos-animate,div[data-aos-delay='450'] [data-aos].aos-animate{transition-delay:.45s}[data-aos][data-aos][data-aos-duration='500'],div[data-aos-duration='500'] [data-aos]{transition-duration:.5s}[data-aos][data-aos][data-aos-delay='500'],div[data-aos-delay='500'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='500'].aos-animate,div[data-aos-delay='500'] [data-aos].aos-animate{transition-delay:.5s}[data-aos][data-aos][data-aos-duration='550'],div[data-aos-duration='550'] [data-aos]{transition-duration:.55s}[data-aos][data-aos][data-aos-delay='550'],div[data-aos-delay='550'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='550'].aos-animate,div[data-aos-delay='550'] [data-aos].aos-animate{transition-delay:.55s}[data-aos][data-aos][data-aos-duration='600'],div[data-aos-duration='600'] [data-aos]{transition-duration:.6s}[data-aos][data-aos][data-aos-delay='600'],div[data-aos-delay='600'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='600'].aos-animate,div[data-aos-delay='600'] [data-aos].aos-animate{transition-delay:.6s}[data-aos][data-aos][data-aos-duration='650'],div[data-aos-duration='650'] [data-aos]{transition-duration:.65s}[data-aos][data-aos][data-aos-delay='650'],div[data-aos-delay='650'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='650'].aos-animate,div[data-aos-delay='650'] [data-aos].aos-animate{transition-delay:.65s}[data-aos][data-aos][data-aos-duration='700'],div[data-aos-duration='700'] [data-aos]{transition-duration:.7s}[data-aos][data-aos][data-aos-delay='700'],div[data-aos-delay='700'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='700'].aos-animate,div[data-aos-delay='700'] [data-aos].aos-animate{transition-delay:.7s}[data-aos][data-aos][data-aos-duration='750'],div[data-aos-duration='750'] [data-aos]{transition-duration:.75s}[data-aos][data-aos][data-aos-delay='750'],div[data-aos-delay='750'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='750'].aos-animate,div[data-aos-delay='750'] [data-aos].aos-animate{transition-delay:.75s}[data-aos][data-aos][data-aos-duration='800'],div[data-aos-duration='800'] [data-aos]{transition-duration:.8s}[data-aos][data-aos][data-aos-delay='800'],div[data-aos-delay='800'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='800'].aos-animate,div[data-aos-delay='800'] [data-aos].aos-animate{transition-delay:.8s}[data-aos][data-aos][data-aos-duration='850'],div[data-aos-duration='850'] [data-aos]{transition-duration:.85s}[data-aos][data-aos][data-aos-delay='850'],div[data-aos-delay='850'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='850'].aos-animate,div[data-aos-delay='850'] [data-aos].aos-animate{transition-delay:.85s}[data-aos][data-aos][data-aos-duration='900'],div[data-aos-duration='900'] [data-aos]{transition-duration:.9s}[data-aos][data-aos][data-aos-delay='900'],div[data-aos-delay='900'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='900'].aos-animate,div[data-aos-delay='900'] [data-aos].aos-animate{transition-delay:.9s}[data-aos][data-aos][data-aos-duration='950'],div[data-aos-duration='950'] [data-aos]{transition-duration:.95s}[data-aos][data-aos][data-aos-delay='950'],div[data-aos-delay='950'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='950'].aos-animate,div[data-aos-delay='950'] [data-aos].aos-animate{transition-delay:.95s}[data-aos][data-aos][data-aos-duration='1000'],div[data-aos-duration='1000'] [data-aos]{transition-duration:1s}[data-aos][data-aos][data-aos-delay='1000'],div[data-aos-delay='1000'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1000'].aos-animate,div[data-aos-delay='1000'] [data-aos].aos-animate{transition-delay:1s}[data-aos][data-aos][data-aos-duration='1050'],div[data-aos-duration='1050'] [data-aos]{transition-duration:1.05s}
[data-aos][data-aos][data-aos-delay='1050'],div[data-aos-delay='1050'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1050'].aos-animate,div[data-aos-delay='1050'] [data-aos].aos-animate{transition-delay:1.05s}[data-aos][data-aos][data-aos-duration='1100'],div[data-aos-duration='1100'] [data-aos]{transition-duration:1.1s}[data-aos][data-aos][data-aos-delay='1100'],div[data-aos-delay='1100'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1100'].aos-animate,div[data-aos-delay='1100'] [data-aos].aos-animate{transition-delay:1.1s}[data-aos][data-aos][data-aos-duration='1150'],div[data-aos-duration='1150'] [data-aos]{transition-duration:1.15s}[data-aos][data-aos][data-aos-delay='1150'],div[data-aos-delay='1150'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1150'].aos-animate,div[data-aos-delay='1150'] [data-aos].aos-animate{transition-delay:1.15s}[data-aos][data-aos][data-aos-duration='1200'],div[data-aos-duration='1200'] [data-aos]{transition-duration:1.2s}[data-aos][data-aos][data-aos-delay='1200'],div[data-aos-delay='1200'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1200'].aos-animate,div[data-aos-delay='1200'] [data-aos].aos-animate{transition-delay:1.2s}[data-aos][data-aos][data-aos-duration='1250'],div[data-aos-duration='1250'] [data-aos]{transition-duration:1.25s}[data-aos][data-aos][data-aos-delay='1250'],div[data-aos-delay='1250'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1250'].aos-animate,div[data-aos-delay='1250'] [data-aos].aos-animate{transition-delay:1.25s}[data-aos][data-aos][data-aos-duration='1300'],div[data-aos-duration='1300'] [data-aos]{transition-duration:1.3s}[data-aos][data-aos][data-aos-delay='1300'],div[data-aos-delay='1300'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1300'].aos-animate,div[data-aos-delay='1300'] [data-aos].aos-animate{transition-delay:1.3s}[data-aos][data-aos][data-aos-duration='1350'],div[data-aos-duration='1350'] [data-aos]{transition-duration:1.35s}[data-aos][data-aos][data-aos-delay='1350'],div[data-aos-delay='1350'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1350'].aos-animate,div[data-aos-delay='1350'] [data-aos].aos-animate{transition-delay:1.35s}[data-aos][data-aos][data-aos-duration='1400'],div[data-aos-duration='1400'] [data-aos]{transition-duration:1.4s}[data-aos][data-aos][data-aos-delay='1400'],div[data-aos-delay='1400'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1400'].aos-animate,div[data-aos-delay='1400'] [data-aos].aos-animate{transition-delay:1.4s}[data-aos][data-aos][data-aos-duration='1450'],div[data-aos-duration='1450'] [data-aos]{transition-duration:1.45s}[data-aos][data-aos][data-aos-delay='1450'],div[data-aos-delay='1450'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1450'].aos-animate,div[data-aos-delay='1450'] [data-aos].aos-animate{transition-delay:1.45s}[data-aos][data-aos][data-aos-duration='1500'],div[data-aos-duration='1500'] [data-aos]{transition-duration:1.5s}[data-aos][data-aos][data-aos-delay='1500'],div[data-aos-delay='1500'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1500'].aos-animate,div[data-aos-delay='1500'] [data-aos].aos-animate{transition-delay:1.5s}[data-aos][data-aos][data-aos-duration='1550'],div[data-aos-duration='1550'] [data-aos]{transition-duration:1.55s}[data-aos][data-aos][data-aos-delay='1550'],div[data-aos-delay='1550'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1550'].aos-animate,div[data-aos-delay='1550'] [data-aos].aos-animate{transition-delay:1.55s}[data-aos][data-aos][data-aos-duration='1600'],div[data-aos-duration='1600'] [data-aos]{transition-duration:1.6s}[data-aos][data-aos][data-aos-delay='1600'],div[data-aos-delay='1600'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1600'].aos-animate,div[data-aos-delay='1600'] [data-aos].aos-animate{transition-delay:1.6s}[data-aos][data-aos][data-aos-duration='1650'],div[data-aos-duration='1650'] [data-aos]{transition-duration:1.65s}[data-aos][data-aos][data-aos-delay='1650'],div[data-aos-delay='1650'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1650'].aos-animate,div[data-aos-delay='1650'] [data-aos].aos-animate{transition-delay:1.65s}[data-aos][data-aos][data-aos-duration='1700'],div[data-aos-duration='1700'] [data-aos]{transition-duration:1.7s}[data-aos][data-aos][data-aos-delay='1700'],div[data-aos-delay='1700'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1700'].aos-animate,div[data-aos-delay='1700'] [data-aos].aos-animate{transition-delay:1.7s}[data-aos][data-aos][data-aos-duration='1750'],div[data-aos-duration='1750'] [data-aos]{transition-duration:1.75s}[data-aos][data-aos][data-aos-delay='1750'],div[data-aos-delay='1750'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1750'].aos-animate,div[data-aos-delay='1750'] [data-aos].aos-animate{transition-delay:1.75s}[data-aos][data-aos][data-aos-duration='1800'],div[data-aos-duration='1800'] [data-aos]{transition-duration:1.8s}[data-aos][data-aos][data-aos-delay='1800'],div[data-aos-delay='1800'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1800'].aos-animate,div[data-aos-delay='1800'] [data-aos].aos-animate{transition-delay:1.8s}[data-aos][data-aos][data-aos-duration='1850'],div[data-aos-duration='1850'] [data-aos]{transition-duration:1.85s}[data-aos][data-aos][data-aos-delay='1850'],div[data-aos-delay='1850'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1850'].aos-animate,div[data-aos-delay='1850'] [data-aos].aos-animate{transition-delay:1.85s}[data-aos][data-aos][data-aos-duration='1900'],div[data-aos-duration='1900'] [data-aos]{transition-duration:1.9s}[data-aos][data-aos][data-aos-delay='1900'],div[data-aos-delay='1900'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1900'].aos-animate,div[data-aos-delay='1900'] [data-aos].aos-animate{transition-delay:1.9s}[data-aos][data-aos][data-aos-duration='1950'],div[data-aos-duration='1950'] [data-aos]{transition-duration:1.95s}[data-aos][data-aos][data-aos-delay='1950'],div[data-aos-delay='1950'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1950'].aos-animate,div[data-aos-delay='1950'] [data-aos].aos-animate{transition-delay:1.95s}[data-aos][data-aos][data-aos-duration='2000'],div[data-aos-duration='2000'] [data-aos]{transition-duration:2s}[data-aos][data-aos][data-aos-delay='2000'],div[data-aos-delay='2000'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2000'].aos-animate,div[data-aos-delay='2000'] [data-aos].aos-animate{transition-delay:2s}[data-aos][data-aos][data-aos-duration='2050'],div[data-aos-duration='2050'] [data-aos]{transition-duration:2.05s}[data-aos][data-aos][data-aos-delay='2050'],div[data-aos-delay='2050'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2050'].aos-animate,div[data-aos-delay='2050'] [data-aos].aos-animate{transition-delay:2.05s}[data-aos][data-aos][data-aos-duration='2100'],div[data-aos-duration='2100'] [data-aos]{transition-duration:2.1s}[data-aos][data-aos][data-aos-delay='2100'],div[data-aos-delay='2100'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2100'].aos-animate,div[data-aos-delay='2100'] [data-aos].aos-animate{transition-delay:2.1s}[data-aos][data-aos][data-aos-duration='2150'],div[data-aos-duration='2150'] [data-aos]{transition-duration:2.15s}[data-aos][data-aos][data-aos-delay='2150'],div[data-aos-delay='2150'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2150'].aos-animate,div[data-aos-delay='2150'] [data-aos].aos-animate{transition-delay:2.15s}[data-aos][data-aos][data-aos-duration='2200'],div[data-aos-duration='2200'] [data-aos]{transition-duration:2.2s}[data-aos][data-aos][data-aos-delay='2200'],div[data-aos-delay='2200'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2200'].aos-animate,div[data-aos-delay='2200'] [data-aos].aos-animate{transition-delay:2.2s}[data-aos][data-aos][data-aos-duration='2250'],div[data-aos-duration='2250'] [data-aos]{transition-duration:2.25s}[data-aos][data-aos][data-aos-delay='2250'],div[data-aos-delay='2250'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2250'].aos-animate,div[data-aos-delay='2250'] [data-aos].aos-animate{transition-delay:2.25s}[data-aos][data-aos][data-aos-duration='2300'],div[data-aos-duration='2300'] [data-aos]{transition-duration:2.3s}[data-aos][data-aos][data-aos-delay='2300'],div[data-aos-delay='2300'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2300'].aos-animate,div[data-aos-delay='2300'] [data-aos].aos-animate{transition-delay:2.3s}[data-aos][data-aos][data-aos-duration='2350'],div[data-aos-duration='2350'] [data-aos]{transition-duration:2.35s}[data-aos][data-aos][data-aos-delay='2350'],div[data-aos-delay='2350'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2350'].aos-animate,div[data-aos-delay='2350'] [data-aos].aos-animate{transition-delay:2.35s}[data-aos][data-aos][data-aos-duration='2400'],div[data-aos-duration='2400'] [data-aos]{transition-duration:2.4s}[data-aos][data-aos][data-aos-delay='2400'],div[data-aos-delay='2400'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2400'].aos-animate,div[data-aos-delay='2400'] [data-aos].aos-animate{transition-delay:2.4s}[data-aos][data-aos][data-aos-duration='2450'],div[data-aos-duration='2450'] [data-aos]{transition-duration:2.45s}[data-aos][data-aos][data-aos-delay='2450'],div[data-aos-delay='2450'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2450'].aos-animate,div[data-aos-delay='2450'] [data-aos].aos-animate{transition-delay:2.45s}[data-aos][data-aos][data-aos-duration='2500'],div[data-aos-duration='2500'] [data-aos]{transition-duration:2.5s}[data-aos][data-aos][data-aos-delay='2500'],
div[data-aos-delay='2500'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2500'].aos-animate,div[data-aos-delay='2500'] [data-aos].aos-animate{transition-delay:2.5s}[data-aos][data-aos][data-aos-duration='2550'],div[data-aos-duration='2550'] [data-aos]{transition-duration:2.55s}[data-aos][data-aos][data-aos-delay='2550'],div[data-aos-delay='2550'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2550'].aos-animate,div[data-aos-delay='2550'] [data-aos].aos-animate{transition-delay:2.55s}[data-aos][data-aos][data-aos-duration='2600'],div[data-aos-duration='2600'] [data-aos]{transition-duration:2.6s}[data-aos][data-aos][data-aos-delay='2600'],div[data-aos-delay='2600'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2600'].aos-animate,div[data-aos-delay='2600'] [data-aos].aos-animate{transition-delay:2.6s}[data-aos][data-aos][data-aos-duration='2650'],div[data-aos-duration='2650'] [data-aos]{transition-duration:2.65s}[data-aos][data-aos][data-aos-delay='2650'],div[data-aos-delay='2650'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2650'].aos-animate,div[data-aos-delay='2650'] [data-aos].aos-animate{transition-delay:2.65s}[data-aos][data-aos][data-aos-duration='2700'],div[data-aos-duration='2700'] [data-aos]{transition-duration:2.7s}[data-aos][data-aos][data-aos-delay='2700'],div[data-aos-delay='2700'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2700'].aos-animate,div[data-aos-delay='2700'] [data-aos].aos-animate{transition-delay:2.7s}[data-aos][data-aos][data-aos-duration='2750'],div[data-aos-duration='2750'] [data-aos]{transition-duration:2.75s}[data-aos][data-aos][data-aos-delay='2750'],div[data-aos-delay='2750'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2750'].aos-animate,div[data-aos-delay='2750'] [data-aos].aos-animate{transition-delay:2.75s}[data-aos][data-aos][data-aos-duration='2800'],div[data-aos-duration='2800'] [data-aos]{transition-duration:2.8s}[data-aos][data-aos][data-aos-delay='2800'],div[data-aos-delay='2800'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2800'].aos-animate,div[data-aos-delay='2800'] [data-aos].aos-animate{transition-delay:2.8s}[data-aos][data-aos][data-aos-duration='2850'],div[data-aos-duration='2850'] [data-aos]{transition-duration:2.85s}[data-aos][data-aos][data-aos-delay='2850'],div[data-aos-delay='2850'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2850'].aos-animate,div[data-aos-delay='2850'] [data-aos].aos-animate{transition-delay:2.85s}[data-aos][data-aos][data-aos-duration='2900'],div[data-aos-duration='2900'] [data-aos]{transition-duration:2.9s}[data-aos][data-aos][data-aos-delay='2900'],div[data-aos-delay='2900'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2900'].aos-animate,div[data-aos-delay='2900'] [data-aos].aos-animate{transition-delay:2.9s}[data-aos][data-aos][data-aos-duration='2950'],div[data-aos-duration='2950'] [data-aos]{transition-duration:2.95s}[data-aos][data-aos][data-aos-delay='2950'],div[data-aos-delay='2950'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2950'].aos-animate,div[data-aos-delay='2950'] [data-aos].aos-animate{transition-delay:2.95s}[data-aos][data-aos][data-aos-duration='3000'],div[data-aos-duration='3000'] [data-aos]{transition-duration:3s}[data-aos][data-aos][data-aos-delay='3000'],div[data-aos-delay='3000'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='3000'].aos-animate,div[data-aos-delay='3000'] [data-aos].aos-animate{transition-delay:3s}[data-aos][data-aos][data-aos-easing=linear],div[data-aos-easing=linear] [data-aos]{transition-timing-function:cubic-bezier(.25,.25,.75,.75)}[data-aos][data-aos][data-aos-easing=ease],div[data-aos-easing=ease] [data-aos]{transition-timing-function:ease}[data-aos][data-aos][data-aos-easing=ease-in],div[data-aos-easing=ease-in] [data-aos]{transition-timing-function:ease-in}[data-aos][data-aos][data-aos-easing=ease-out],div[data-aos-easing=ease-out] [data-aos]{transition-timing-function:ease-out}[data-aos][data-aos][data-aos-easing=ease-in-out],div[data-aos-easing=ease-in-out] [data-aos]{transition-timing-function:ease-in-out}[data-aos][data-aos][data-aos-easing=ease-in-back],div[data-aos-easing=ease-in-back] [data-aos]{transition-timing-function:cubic-bezier(.6,-.28,.735,.045)}[data-aos][data-aos][data-aos-easing=ease-out-back],div[data-aos-easing=ease-out-back] [data-aos]{transition-timing-function:cubic-bezier(.175,.885,.32,1.275)}[data-aos][data-aos][data-aos-easing=ease-in-out-back],div[data-aos-easing=ease-in-out-back] [data-aos]{transition-timing-function:cubic-bezier(.68,-.55,.265,1.55)}[data-aos][data-aos][data-aos-easing=ease-in-sine],div[data-aos-easing=ease-in-sine] [data-aos]{transition-timing-function:cubic-bezier(.47,0,.745,.715)}[data-aos][data-aos][data-aos-easing=ease-out-sine],div[data-aos-easing=ease-out-sine] [data-aos]{transition-timing-function:cubic-bezier(.39,.575,.565,1)}[data-aos][data-aos][data-aos-easing=ease-in-out-sine],div[data-aos-easing=ease-in-out-sine] [data-aos]{transition-timing-function:cubic-bezier(.445,.05,.55,.95)}[data-aos][data-aos][data-aos-easing=ease-in-quad],div[data-aos-easing=ease-in-quad] [data-aos]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-aos][data-aos][data-aos-easing=ease-out-quad],div[data-aos-easing=ease-out-quad] [data-aos]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-aos][data-aos][data-aos-easing=ease-in-out-quad],div[data-aos-easing=ease-in-out-quad] [data-aos]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-aos][data-aos][data-aos-easing=ease-in-cubic],div[data-aos-easing=ease-in-cubic] [data-aos]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-aos][data-aos][data-aos-easing=ease-out-cubic],div[data-aos-easing=ease-out-cubic] [data-aos]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-aos][data-aos][data-aos-easing=ease-in-out-cubic],div[data-aos-easing=ease-in-out-cubic] [data-aos]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-aos][data-aos][data-aos-easing=ease-in-quart],div[data-aos-easing=ease-in-quart] [data-aos]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-aos][data-aos][data-aos-easing=ease-out-quart],div[data-aos-easing=ease-out-quart] [data-aos]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-aos][data-aos][data-aos-easing=ease-in-out-quart],div[data-aos-easing=ease-in-out-quart] [data-aos]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-aos^=fade][data-aos^=fade]{opacity:0;transition-property:opacity,transform}[data-aos^=fade][data-aos^=fade].aos-animate{opacity:1;transform:translate(0)}[data-aos=fade-up]{transform:translateY(100px)}[data-aos=fade-down]{transform:translateY(-100px)}
[data-aos=fade-right]{transform:translate(-100px)}
[data-aos=fade-left]{transform:translate(-100px)  }
[data-aos=fade-up-right]{transform:translate(-100px,100px)}
[data-aos=fade-up-left]{transform:translate(100px,100px)}
[data-aos=fade-down-right]{transform:translate(-100px,-100px)}
[data-aos=fade-down-left]{transform:translate(100px,-100px)}
[data-aos^=zoom][data-aos^=zoom]{opacity:0;transition-property:opacity,transform}[data-aos^=zoom][data-aos^=zoom]
.aos-animate{opacity:1;transform:translate(0) scale(1)}
[data-aos=zoom-in]{transform:scale(.6)}[data-aos=zoom-in-up]{transform:translateY(100px) scale(.6)}[data-aos=zoom-in-down]{transform:translateY(-100px) scale(.6)}
[data-aos=zoom-in-right]{transform:translate(-100px) scale(.6)}[data-aos=zoom-in-left]{transform:translate(100px) scale(.6)}[data-aos=zoom-out]{transform:scale(1.2)}
[data-aos=zoom-out-up]{transform:translateY(100px) scale(1.2)}[data-aos=zoom-out-down]{transform:translateY(-100px) scale(1.2)}
[data-aos=zoom-out-right]{transform:translate(-100px) scale(1.2)}[data-aos=zoom-out-left]{transform:translate(100px) scale(1.2)}
[data-aos^=slide][data-aos^=slide]{transition-property:transform}[data-aos^=slide][data-aos^=slide].aos-animate{transform:translate(0)}
[data-aos=slide-up]{transform:translateY(100%)}[data-aos=slide-down]{transform:translateY(-100%)}[data-aos=slide-right]{transform:translateX(-100%)}[data-aos=slide-left]{transform:translateX(100%)}[data-aos^=flip][data-aos^=flip]{backface-visibility:hidden;transition-property:transform}[data-aos=flip-left]{transform:perspective(2500px) rotateY(-100deg)}[data-aos=flip-left].aos-animate{transform:perspective(2500px) rotateY(0)}[data-aos=flip-right]{transform:perspective(2500px) rotateY(100deg)}[data-aos=flip-right].aos-animate{transform:perspective(2500px) rotateY(0)}[data-aos=flip-up]{transform:perspective(2500px) rotateX(-100deg)}[data-aos=flip-up].aos-animate{transform:perspective(2500px) rotateX(0)}[data-aos=flip-down]{transform:perspective(2500px) rotateX(100deg)}[data-aos=flip-down].aos-animate{transform:perspective(2500px) rotateX(0)}
/*# animate aos.css*/

}
</style>
